import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './Label.styles';

const Label = props => {
  const { children, styles: customStyles, ...rest } = props;
  return (
    <label className={css(styles.base, customStyles)} {...rest}>
      {children}
    </label>
  );
};

export default Label;



// WEBPACK FOOTER //
// ./src/components/common/label/Label.js